import { apiCall } from '@/util/apiCall'
import type { NextTrip } from '@common/types/NextTrip'
import { setNextTrips } from '../nextTrips'
import { makeTracker } from './track'

export const trackNextTripsArea = makeTracker<{
	area: string
}>({
	id: ({ area }) => `nexttrips:${area}`,
	loader: async (api, { area }) => {
		const { data: trips } = await apiCall<{ data: NextTrip[] }>(
			'/next-trips/areas/:area',
			{
				signal: api.signal,
				params: { area },
				cache: 'no-cache',
			},
		)
		return setNextTrips(trips)
	},
})
